
import React from 'react';
import Layout from '@/components/Layout/Layout';
import ScientificCalculator from '@/components/Calculator/ScientificCalculator';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const ScientificCalculatorPage = () => {
  return (
    <Layout>
      <div className="container mx-auto max-w-3xl px-4">
        <div className="mb-6">
          <Link to="/calculators" className="flex items-center text-primary hover:underline mb-2">
            <ArrowLeft size={16} className="mr-1" />
            Back to All Calculators
          </Link>
          <h1 className="text-3xl font-bold mb-2">Scientific Calculator</h1>
          <p className="text-gray-600 mb-6">
            Advanced calculator with trigonometric, logarithmic, and exponential functions.
          </p>
        </div>
        
        <div className="mb-8">
          <ScientificCalculator />
        </div>
        
        <div className="mt-10 prose max-w-none">
          <h2 className="text-xl font-semibold mb-4">About Scientific Calculator</h2>
          <p>
            The scientific calculator offers advanced mathematical functions for students, 
            engineers, scientists, and anyone who needs more than basic arithmetic.
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Advanced Functions</h3>
          <ul className="list-disc ml-6">
            <li>Trigonometric functions (sin, cos, tan)</li>
            <li>Logarithmic operations (log, ln)</li>
            <li>Exponential calculations</li>
            <li>Square root and power functions</li>
            <li>Memory functions</li>
            <li>Constants (π, e)</li>
          </ul>
          
          <h3 className="text-lg font-medium mt-6 mb-2">How to Use</h3>
          <p>
            Enter your expression using the calculator interface. For complex calculations, 
            remember to follow the order of operations (parentheses, exponents, multiplication/division, 
            addition/subtraction).
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default ScientificCalculatorPage;
